export default __webpack_public_path__ + "static/media/modelo-resposta-icon.0b137ef7.svg";